import { z } from "zod";

export const serverResponse = z.object({
  code: z.string(),
});
